import Vue from 'vue'
import Router from 'vue-router';
import homeMain from '@/router/homeMain.js'
const login = resolve => require(['@/components/login/login/index.vue'], resolve);
const stopPage = resolve => require(['@/components/stopPage/index.vue'], resolve);
Vue.use(Router)
let stopPageFlag=false;
const router = new Router({
    routes: [
        {
            path: '/',
            component:(stopPageFlag)?stopPage:login,
            meta: {
                role: true
            }
        },
        ...homeMain,
        {
            path: "*",
            redirect: '/',
        }
    ]
})

// 路由拦截
router.beforeEach((to, from, next) => {
    if (!to.meta.role) {
        if (sessionStorage.getItem("userLoginId") && !stopPageFlag) {
            next()
        } else {
            next({
                path: "/"
            })
        }
    } else {
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js